module.exports = __webpack_public_path__ + "static/media/R-180HD_CrossSection.f9fc168d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-180HD_CrossSection.png
// module id = 476
// module chunks = 0